import { useNavigate } from 'react-router-dom';
import Button from './Button';

const NoPermission = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-4 items-center justify-center h-full">
      <h1 className="text-2xl font-bold">No Permission</h1>
      <p className="text-sm text-gray-500">
        You do not have permission to access this page.
      </p>
      <Button onClick={() => navigate('/')}>Go to Home</Button>
    </div>
  );
};

export default NoPermission;
